export class MediaBreakpoints {
  constructor() {
    this.breakpoints = {
      xs: 450,
      sm: 768,
      md: 900,
      lg: 1200,
      xlg: 1440,
      xxlg: 1600
    };
  }

  get isXxs() {
    return window.innerWidth > this.breakpoints.xs;
  }

  get isXs() {
    return window.innerWidth > this.breakpoints.xs;
  }

  get isSm() {
    return window.innerWidth >= this.breakpoints.sm;
  }

  get isMd() {
    return window.innerWidth > this.breakpoints.md;
  }

  get isLg() {
    return window.innerWidth > this.breakpoints.lg;
  }

  get isXlg() {
    return window.innerWidth >= this.breakpoints.xlg;
  }

  get isXxlg() {
    return window.innerWidth >= this.breakpoints.xxlg;
  }

  get isXxsViewport() {
    return window.innerWidth <= this.breakpoints.xs;
  }

  get isXsViewport() {
    return window.innerWidth < this.breakpoints.sm;
  }

  get isSmViewport() {
    return this.breakpoints.sm <= window.innerWidth && window.innerWidth <= this.breakpoints.md;
  }

  get isMdViewport() {
    return this.breakpoints.md < window.innerWidth && window.innerWidth <= this.breakpoints.lg;
  }

  get isLgViewport() {
    return this.breakpoints.lg < window.innerWidth && window.innerWidth < this.breakpoints.xlg;
  }

}